import { useLanguage } from "@/LanguageContext";
import { Asterisk } from "@/components/Reveal";

const Marquee = () => {
  const { t } = useLanguage();
  return (
    <section className="overflow-hidden border-y border-noom-line bg-white py-5" data-testid="marquee-strip">
      <div className="marquee-track items-center">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {t.marquee.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-lg font-medium uppercase tracking-[0.08em] text-noom-ink sm:text-xl">
                  {item}
                </span>
                <Asterisk className="h-4 w-4 shrink-0 text-noom-lilac" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
